import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import { Help, Mail, LogoImg } from '../../ui-components/Icons';
import clsx from 'clsx';

interface IProps {
    classes: any
}
export const BottomBar = (props: IProps) => {
    const { classes } = props;
    return (
        <footer className={classes.footer}>
            <Grid container className={classes.footerRow}>
                <Grid item xs={12} className={classes.footerItem}>
                    <Help fill="#FFF" className={clsx(classes.footerIcon, classes.iconSminchia)} />
                    {/* <Privacy fill="#FFF" className={classes.footerIcon} /> */}
                </Grid>
                <Grid item className={clsx(classes.footerItem, classes.flexEnd)}>
                    <a href={`mailto:customercare@logico.srl`}>
                        <IconButton>
                            <Mail fill="#FFF" className={classes.footerIcon} />
                        </IconButton>
                    </a>
                    <LogoImg className={classes.footerIcon} style={{ width: 'auto' }} />
                </Grid>

            </Grid>
        </footer>
    )
}